import React from 'react';
import '../../../features/home/categories/ProductGallery.css';

const GalleryLayout1 = ({products}) => {
  // Define product data (this makes the component dynamic in React)
//   const products = [
//     { id: 1, name: 'Product 1', imageUrl: '/assets/images/pattu-soft-silk-saree-1.jpeg', price: '$19.99' },
//     { id: 2, name: 'Product 2', imageUrl: '/assets/images/royal-rajwari-katan-silk.jpeg', price: '$29.99' },
//     { id: 3, name: 'Product 3', imageUrl: '/assets/images/rajwari-katan-silk-minakari-saree.jpg', price: '$39.99' },
//   ];

  return (
    <section className="mbr-section mbr-gallery" id="product-gallery-1">
      <div className="container">
        <div className="row mbr-gallery-row">
          {products.map((product) => (
            <div className="col-md-4 mbr-gallery-item" key={product.id}>
              <div className="card">
                <img src={product.imageUrl} alt={product.name} />
                <div className="card-body">
                  <h5 className="card-title">{product.name}</h5>
                  <p className="card-text">{product.price}</p>
                  {/* You can add React event handlers here, e.g., onClick */}
                  <button className="btn btn-primary">Add to Cart</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default GalleryLayout1;
